import styled from "styled-components";

export const Heading = styled.h1.attrs(({ as }) => ({ as: as || "h1" }))`
  margin: 0;
  font-size: ${({ theme, $size = "2xl" }) =>
    theme.typography.sizes[$size] || theme.typography.sizes["2xl"]};
  font-weight: ${({ theme }) => theme.typography.weights.medium};
  line-height: ${({ theme }) => theme.typography.lineHeights.heading};
  color: ${({ theme }) => theme.colors.text};
`;

export const Text = styled.p`
  margin: 0;
  font-size: ${({ theme, $size = "md" }) =>
    theme.typography.sizes[$size] || theme.typography.sizes.md};
  font-weight: ${({ theme }) => theme.typography.weights.regular};
  line-height: ${({ theme }) => theme.typography.lineHeights.body};
  color: ${({ theme, $muted }) =>
    $muted ? theme.colors.textMuted : theme.colors.text};
`;

export const Label = styled.label`
  display: block;
  margin: 0;
  font-size: ${({ theme }) => theme.typography.sizes.xs};
  font-weight: ${({ theme }) => theme.typography.weights.medium};
  line-height: ${({ theme }) => theme.typography.lineHeights.body};
  color: ${({ theme }) => theme.colors.textMuted};
  letter-spacing: 0.02em;
  text-transform: uppercase;
`;
